import React, { useMemo } from 'react';
import _ from 'underscore';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import { i18nKeys } from '@bingads-webui-react/file-picker';
import { StringUtils } from '@bingads-webui-clientcenter/common-utils';
import { TaxTypeFormPropTypes } from '../shapes';
import { GlobalTaxForm } from './global-taxform';
import { EmptyTaxForm } from './empty-taxform';
import { registerTaxform } from '../taxform-store';
import { EmptyViewTaxForm } from './viewtaxforms/empty-viewtaxform';
import { ILTaxViewTaxForm } from './viewtaxforms/israel-viewtaxform';
import { CustomValidateItems } from '../validator';
import { withViewTaxFormWithFilledEmptyTaxValue, withTaxFormByPilot, getTaxTypeLabel } from '../utils';
import { GlobalTaxIdHelpPopUpId, FileScenarioMapping, GlobalTaxIdCountryCodeToPilots, GlobalFilePickerRequiredErrorMessage } from '../constants';

const {
  TaxILVatNumberRegExp, TaxType, TaxCertLabel, TaxLabelFormat, CountryCode,
} = Constants;
const { regexTest } = StringUtils;
const taxIdValidator = _.partial(regexTest, TaxILVatNumberRegExp);

const taxSchemaGetter = () => ({
  name: 'Israel Taxation Validation Schema',
  type: 'object',
  properties: {
    [TaxType.VatNumber]: {
      type: 'string',
      required: false,
      helpPopupTopic: GlobalTaxIdHelpPopUpId,
    },
  },
});

const ILTaxForm = ({
  i18n,
  onValidate,
  showLineByLineFormGroup,
  showTaxFilePicker,
  alwaysShowError,
  data,
  mtData,
  taxCertification,
  mtTaxCertification,
  urlBuilder,
  disabled,
}) => {
  const taxCertLabel = useMemo(() => i18n.getString(TaxCertLabel.TaxCertificateOrEquivalentProof), [i18n]);
  const taxTypeLabel = useMemo(() => getTaxTypeLabel(TaxType.VatNumber, i18n, { countryCode: CountryCode.IL }), [i18n]);
  const vatValidatorErrorMessage = useMemo(() => i18n.getString(CustomValidateItems.IsraelVATFormatValidation), [i18n]);
  const vatLabel = useMemo(() => getTaxTypeLabel(TaxType.VatNumber, i18n, { labelFormat: TaxLabelFormat.RequiredForBusiness, countryCode: CountryCode.IL }), [i18n]);
  const customStrings = useMemo(() => ({
    [i18nKeys.FilePicker_ErrorMessage_Required]: i18n.getString(GlobalFilePickerRequiredErrorMessage, {
      taxId: taxTypeLabel,
    }),
  }), [i18n, taxTypeLabel]);

  return (
    <GlobalTaxForm
      i18n={i18n}
      onValidate={onValidate}
      taxSchemaGetter={taxSchemaGetter}
      vatLabel={vatLabel}
      customStrings={customStrings}
      showLineByLineFormGroup={showLineByLineFormGroup}
      vatValidatorErrorMessage={vatValidatorErrorMessage}
      showTaxFilePicker={showTaxFilePicker}
      alwaysShowError={alwaysShowError}
      data={data}
      mtData={mtData}
      taxCertification={taxCertification}
      mtTaxCertification={mtTaxCertification}
      urlBuilder={urlBuilder}
      disabled={disabled}
      taxIdValidator={taxIdValidator}
      taxCertLabel={taxCertLabel}
      taxCertScenario={FileScenarioMapping.IL}
    />
  );
};

ILTaxForm.propTypes = TaxTypeFormPropTypes;

const pilotFlag = GlobalTaxIdCountryCodeToPilots.IL;
const TaxForm = withTaxFormByPilot({ pilotFlag, PilotForm: ILTaxForm, DefaultForm: EmptyTaxForm });
const ViewTaxForm = withTaxFormByPilot({ pilotFlag, PilotForm: ILTaxViewTaxForm, DefaultForm: EmptyViewTaxForm });

registerTaxform('/IL/', TaxForm, withViewTaxFormWithFilledEmptyTaxValue({ ViewTaxForm, getTaxSchema: taxSchemaGetter }));
